
export function startBulkImport (options) {
  return import('./workflow')
    .then(module => {
      const startWorkflow = module.startWorkflow
      return startWorkflow(options)
    })
}
